/*
 * kokoot — mobile drawer menu enhancement
 *
 * What:
 *   1. Override 5 一级 collection titles in the mobile drawer to be more descriptive (Scheme B).
 *      Desktop top nav DOM (.menu-list__link) is untouched — only the drawer (.menu-drawer__*) is touched.
 *   2. Convert flat <ul>-of-<li> drawer items into accordion: nested <ul> children are hidden by
 *      default, tap on the 一级 row toggles. Caret rotates 0deg → 90deg on open.
 *
 * Scope:
 *   - Runs anytime the DOM contains .menu-drawer (the drawer DOM exists always, but is CSS-hidden
 *     on desktop). All visual changes are scoped via the .menu-drawer ancestor in CSS.
 */
(function () {
  'use strict';

  // Map: 一级 collection href → mobile-friendly label
  var LABELS = {
    '/collections/toys-enrichment': 'Toys & Play',
    '/collections/apparel-accessories': 'Clothing & Wear',
    '/collections/travel-outdoor': 'Travel & Outdoor',
    '/collections/home-bedding': 'Home & Bedding',
    '/collections/cleaning-care': 'Care & Cleaning',
  };

  function applyMobileMenu() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return false;
    if (drawer.dataset.kokootApplied === '1') return true;
    drawer.dataset.kokootApplied = '1';

    // 1. Override 一级 titles (only items that match our 5 一级 hrefs)
    // Tinker wraps the label in <span class="menu-drawer__menu-item-text wrap-text">…</span>
    var mainLinks = drawer.querySelectorAll('a.menu-drawer__menu-item--mainlist');
    mainLinks.forEach(function (a) {
      var href = a.getAttribute('href');
      var newLabel = LABELS[href];
      if (!newLabel) return;
      var textSpan = a.querySelector('.menu-drawer__menu-item-text');
      if (textSpan) {
        textSpan.textContent = newLabel;
        return;
      }
      // Fallback: replace first non-whitespace text node
      for (var i = 0; i < a.childNodes.length; i++) {
        var node = a.childNodes[i];
        if (node.nodeType === 3 /* TEXT */ && node.nodeValue.trim()) {
          node.nodeValue = ' ' + newLabel + ' ';
          break;
        }
      }
    });

    // 2. Accordion: mark each <li> with nested <ul>, hide children, add caret indicator
    //    Click handling is via event delegation on the drawer (more robust to Tinker hydration).
    var topItems = drawer.querySelectorAll('.menu-drawer__menu > li');
    topItems.forEach(function (li) {
      var nestedUl = li.querySelector(':scope > ul');
      if (!nestedUl) return; // leaf — skip
      var mainAnchor = li.querySelector(':scope > a');
      if (!mainAnchor) return;

      li.classList.add('kokoot-acc-li');
      nestedUl.style.display = 'none';

      // Append caret (rotates 90deg via CSS when .kokoot-acc-open)
      if (!mainAnchor.querySelector('.kokoot-acc-caret')) {
        var caret = document.createElement('span');
        caret.className = 'kokoot-acc-caret';
        caret.setAttribute('aria-hidden', 'true');
        caret.textContent = '›';
        mainAnchor.appendChild(caret);
      }

      mainAnchor.setAttribute('aria-expanded', 'false');
      mainAnchor.setAttribute('role', 'button');
    });

    return true;
  }

  // Event delegation: listen on the drawer container in CAPTURE phase to fire BEFORE
  // Tinker's own click handlers (which may navigate or trigger SPA actions).
  function attachClickDelegation() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return false;
    if (drawer.dataset.kokootClickAttached === '1') return true;
    drawer.dataset.kokootClickAttached = '1';

    drawer.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a.menu-drawer__menu-item--mainlist');
      if (!a) return;
      var li = a.closest('.kokoot-acc-li');
      if (!li) return;
      var nestedUl = li.querySelector(':scope > ul');
      if (!nestedUl) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      var isOpen = li.classList.toggle('kokoot-acc-open');
      nestedUl.style.display = isOpen ? 'block' : 'none';
      a.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }, true /* capture */);

    return true;
  }

  function bootstrap() {
    applyMobileMenu();
    attachClickDelegation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  // Safety net: drawer may hydrate after DOMContentLoaded (Tinker header-drawer.js is type=module)
  setTimeout(bootstrap, 500);
  setTimeout(bootstrap, 1500);

  // Observe future drawer additions (Customize editor re-renders, hydration replacements)
  var observer = new MutationObserver(function () {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;
    if (drawer.dataset.kokootApplied !== '1' || drawer.dataset.kokootClickAttached !== '1') {
      bootstrap();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
